function initRelatedProductsCarousel(carousel) {
  if (carousel.dataset.relatedProductsInitialized === 'true') return;

  const track = carousel.querySelector('[data-related-products-track]');
  const items = Array.from(carousel.querySelectorAll('[data-related-product]'));
  const previousButton = carousel.querySelector('[data-related-products-prev]');
  const nextButton = carousel.querySelector('[data-related-products-next]');
  const status = carousel.querySelector('[data-related-products-status]');

  if (!track || items.length === 0) return;

  carousel.dataset.relatedProductsInitialized = 'true';
  let currentIndex = 0;
  let cardHeight = 0;
  let gap = 0;

  function visibleItems() {
    return window.matchMedia('(min-width: 750px)').matches ? 3 : 2;
  }

  function maximumIndex() {
    return Math.max(0, items.length - visibleItems());
  }

  function measure() {
    carousel.style.removeProperty('--related-products-card-height');
    carousel.style.removeProperty('--related-products-viewport-height');

    gap = parseFloat(window.getComputedStyle(track).rowGap) || 0;
    cardHeight = items.reduce(function (tallest, item) {
      return Math.max(tallest, item.getBoundingClientRect().height);
    }, 0);

    if (cardHeight === 0) return false;

    cardHeight = Math.ceil(cardHeight);
    const perView = Math.min(visibleItems(), items.length);
    const viewportHeight = cardHeight * perView + gap * (perView - 1);

    carousel.style.setProperty('--related-products-card-height', cardHeight + 'px');
    carousel.style.setProperty('--related-products-viewport-height', viewportHeight + 'px');

    return true;
  }

  function updateCarousel() {
    if (!measure()) return;

    const maxIndex = maximumIndex();
    currentIndex = Math.min(currentIndex, maxIndex);
    track.style.transform = `translateY(-${currentIndex * (cardHeight + gap)}px)`;

    const hasOverflow = items.length > visibleItems();
    if (previousButton) previousButton.disabled = !hasOverflow || currentIndex === 0;
    if (nextButton) nextButton.disabled = !hasOverflow || currentIndex === maxIndex;
    if (status) {
      const lastVisibleItem = Math.min(items.length, currentIndex + visibleItems());
      status.textContent = `Showing related products ${currentIndex + 1} to ${lastVisibleItem} of ${items.length}`;
    }
  }

  previousButton?.addEventListener('click', function () {
    if (currentIndex > 0) {
      currentIndex -= 1;
      updateCarousel();
    }
  });

  nextButton?.addEventListener('click', function () {
    if (currentIndex < maximumIndex()) {
      currentIndex += 1;
      updateCarousel();
    }
  });

  window.addEventListener('resize', updateCarousel);

  carousel.querySelectorAll('img').forEach(function (image) {
    if (image.complete) return;
    image.addEventListener('load', updateCarousel, { once: true });
    image.addEventListener('error', updateCarousel, { once: true });
  });

  if (document.fonts?.ready) {
    document.fonts.ready.then(updateCarousel);
  }

  updateCarousel();
}

function initRelatedProductsCarousels(root = document) {
  root.querySelectorAll('[data-related-products-carousel]').forEach(initRelatedProductsCarousel);
}

document.addEventListener('DOMContentLoaded', function () {
  initRelatedProductsCarousels();
});

document.addEventListener('shopify:section:load', function (event) {
  initRelatedProductsCarousels(event.target);
});
